import OtherDebt from 'templates/IncomeAndExpendituresPageData/Templates/OtherDebt'

interface Props {
    PageData?: any;
    Model?: any;
    currencyClass?: string;
    IncomeAndExpenditureFormModel: any
    setIncomeAndExpenditureFormModel?: any;
}

const OtherDebtForm = (props: Props) => {
    const { Model, PageData, currencyClass, IncomeAndExpenditureFormModel, setIncomeAndExpenditureFormModel } = props;

    function addOtherDebt() {
        let newFormValues = { ...IncomeAndExpenditureFormModel.OtherDebtFormModel };
        const obj = {
            "debtCreditor": "",
            "debtBalance": 0,
            "debtMonthlyPayment": 0
        };
        newFormValues["Debts"].push(obj);
        setIncomeAndExpenditureFormModel({ ...IncomeAndExpenditureFormModel, OtherDebtFormModel: newFormValues });
    }

    return (
        <div className="IncomeAndExpenditure__formWrapper OtherDebt">
            <form id="otherDebtsForm" className="IncomeAndExpenditure__form OtherDebt__form">
                <p className="IncomeAndExpenditure__formInfo">
                    {PageData?.FormHeaderNote}
                </p>
                <h3 className="OtherDebt__heading">{PageData?.OtherDebtsHeader}</h3>
                <div id="debtItems">
                    <OtherDebt
                        formValues={IncomeAndExpenditureFormModel}
                        setFormValues={setIncomeAndExpenditureFormModel}
                        currencyClass={currencyClass}
                        {...props} />
                </div>
                <div className="OtherDebt__ctaWrapper">
                    <button id="addDebtBtn" type="button" className="OtherDebt__addDebtBtn" onClick={addOtherDebt}>
                        {PageData?.AddAnotherDebtText}
                    </button>
                </div>
                <div className="OtherDebt__summary">
                    <div className="OtherDebt__summaryWrapper">
                        <h3 className="OtherDebt__heading">{PageData?.OtherDebtsTotalText}</h3>
                        <div className="OtherDebt__formRow">
                            <div className="OtherDebt__inputsWrapper">
                                <label className="IncomeAndExpenditure__label">
                                    <span className="IncomeAndExpenditure__labelText">{PageData?.TotalBalancesText}</span>
                                    <div className={"Input Input-icon Input-icon--before " + currencyClass + " Input-textCenter"}>
                                        <input type="text" name="totalDebtBalances" value={IncomeAndExpenditureFormModel.OtherDebtFormModel.totalDebtBalances} className="total-debt-balances non-editable" readOnly placeholder={PageData?.InputAmountPlaceHolderText} />
                                        <span>

                                        </span>
                                    </div>

                                </label>
                                <label className="IncomeAndExpenditure__label">
                                    <span className="IncomeAndExpenditure__labelText">{PageData?.TotalPaymentsText}</span>
                                    <div className={"Input Input-icon Input-icon--before " + currencyClass + " Input-textCenter"}>
                                        <input type="text" name="totalDebtPayments" value={IncomeAndExpenditureFormModel.OtherDebtFormModel.totalDebtPayments} className="total-debt-payments non-editable" readOnly placeholder={PageData?.InputAmountPlaceHolderText} />
                                        <span>

                                        </span>
                                    </div>

                                </label>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    );
};
export default OtherDebtForm;